import type { IEnergyPassportData, IFetchEnergyPassportParams } from "@/entities/energy-passport/types.ts"

import { requestIntensity } from "@/shared/utils/axios.ts"

// export async function fetchEnergyPassport({ year, contractId }: IFetchEnergyPassportParams): Promise<IEnergyPassportData> {
//   // Return fake data instead of making API call
//   return new Promise(resolve => {
//     setTimeout(() => {
//       resolve({
//         id: 1,
//         year: Number(year),
//         quarters: [
//           {
//             id: 1,
//             quarter_number: 1,
//             created_at: "2024-01-15T10:30:00Z",
//             updated_at: "2024-01-15T10:30:00Z",
//             product_count: 2,
//             total: {
//               count: 1000,
//               thermal_energy: 500.5,
//               gas: 200.3,
//               mazut: 150.0,
//               coal: 100.2,
//               gasoline: 50.1,
//               diesel: 75.4,
//               kerosene: 25.0,
//               oils: 30.5,
//               other_petroleum_products: 20.3,
//               water: 1000.0,
//               active_energy: 2500.0,
//               reactive_energy: 1200.0,
//               product_count: 2
//             },
//             products: [
//               {
//                 id: 1,
//                 quarter_number: 1,
//                 product_name: "Steel Production",
//                 count: 500,
//                 count_measure: "tons",
//                 active_energy: 1500.0,
//                 reactive_energy: 800.0,
//                 thermal_energy: 300.5,
//                 gas: 120.3,
//                 mazut: 80.0,
//                 coal: 60.2,
//                 gasoline: 25.1,
//                 diesel: 40.4,
//                 kerosene: 15.0,
//                 oils: 20.5,
//                 other_petroleum_products: 10.3,
//                 water: 600.0,
//                 is_main_product: true,
//                 nameError: false
//               },
//               {
//                 id: 2,
//                 quarter_number: 1,
//                 product_name: "Secondary Products",
//                 count: 500,
//                 count_measure: "units",
//                 active_energy: 1000.0,
//                 reactive_energy: 400.0,
//                 thermal_energy: 200.0,
//                 gas: 80.0,
//                 mazut: 70.0,
//                 coal: 40.0,
//                 gasoline: 25.0,
//                 diesel: 35.0,
//                 kerosene: 10.0,
//                 oils: 10.0,
//                 other_petroleum_products: 10.0,
//                 water: 400.0,
//                 is_main_product: false,
//                 nameError: false
//               }
//             ]
//           },
//           {
//             id: 2,
//             quarter_number: 2,
//             created_at: "2024-04-15T10:30:00Z",
//             updated_at: "2024-04-15T10:30:00Z",
//             product_count: 1,
//             total: {
//               count: 800,
//               thermal_energy: 400.0,
//               gas: 180.0,
//               mazut: 120.0,
//               coal: 80.0,
//               gasoline: 40.0,
//               diesel: 60.0,
//               kerosene: 20.0,
//               oils: 25.0,
//               other_petroleum_products: 15.0,
//               water: 800.0,
//               active_energy: 2000.0,
//               reactive_energy: 1000.0,
//               product_count: 1
//             },
//             products: [
//               {
//                 id: 3,
//                 quarter_number: 2,
//                 product_name: "Steel Production Q2",
//                 count: 800,
//                 count_measure: "tons",
//                 active_energy: 2000.0,
//                 reactive_energy: 1000.0,
//                 thermal_energy: 400.0,
//                 gas: 180.0,
//                 mazut: 120.0,
//                 coal: 80.0,
//                 gasoline: 40.0,
//                 diesel: 60.0,
//                 kerosene: 20.0,
//                 oils: 25.0,
//                 other_petroleum_products: 15.0,
//                 water: 800.0,
//                 is_main_product: true,
//                 nameError: false
//               }
//             ]
//           }
//         ],
//         details: {
//           quarters: [
//             {
//               quarter: 1,
//               energy_type: IEnergyPassportResourceType.ACTIVE_ELECTRICITY,
//               declared_consumption: 2500.0,
//               sub_consumption: 100.0,
//               total_consumption: 2400.0,
//               technical_needs: 200.0,
//               own_needs: 300.0,
//               production_needs: 1800.0,
//               residential_needs: 100.0,
//               consumption_standard: 2.5,
//               max_nominal_capacity_per_hour: 500.0,
//               created_at: "2024-01-15T10:30:00Z",
//               updated_at: "2024-01-15T10:30:00Z"
//             },
//             {
//               quarter: 1,
//               energy_type: IEnergyPassportResourceType.GAS,
//               declared_consumption: 200.0,
//               sub_consumption: 10.0,
//               total_consumption: 190.0,
//               technical_needs: 20.0,
//               own_needs: 30.0,
//               production_needs: 130.0,
//               residential_needs: 10.0,
//               consumption_standard: 0.2,
//               max_nominal_capacity_per_hour: 50.0,
//               created_at: "2024-01-15T10:30:00Z",
//               updated_at: "2024-01-15T10:30:00Z"
//             },
//             {
//               quarter: 2,
//               energy_type: IEnergyPassportResourceType.ACTIVE_ELECTRICITY,
//               declared_consumption: 2000.0,
//               sub_consumption: 80.0,
//               total_consumption: 1920.0,
//               technical_needs: 150.0,
//               own_needs: 250.0,
//               production_needs: 1450.0,
//               residential_needs: 70.0,
//               consumption_standard: 2.4,
//               max_nominal_capacity_per_hour: 480.0,
//               created_at: "2024-04-15T10:30:00Z",
//               updated_at: "2024-04-15T10:30:00Z"
//             }
//           ],
//           totals: {
//             energy_type: IEnergyPassportResourceType.ACTIVE_ELECTRICITY,
//             declared_consumption: 4500.0,
//             sub_consumption: 180.0,
//             total_consumption: 4320.0,
//             technical_needs: 350.0,
//             own_needs: 550.0,
//             production_needs: 3250.0,
//             residential_needs: 170.0,
//             consumption_standard: 4.9,
//             max_nominal_capacity_per_hour: 980.0
//           }
//         },
//         created_at: "2024-01-01T00:00:00Z",
//         updated_at: "2024-04-15T10:30:00Z"
//       })
//     }, 800) // 800ms delay to simulate network request
//   })
// }

// Original implementation (commented out)
export async function fetchEnergyPassport({ year, contractId }: IFetchEnergyPassportParams) {
  const { data } = await requestIntensity(`/passports/${contractId}/${year}/`)
  return data as IEnergyPassportData
}
